module.exports = __webpack_public_path__ + "static/media/b1.55ee047c.jpg";